export var formattingOptions = {
  shortMonth: {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  },
  longMonth: {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }
};
export var makeDateFormatter = function makeDateFormatter(lng, formattingOption) {
  var dateFormatter = new Intl.DateTimeFormat(lng, formattingOptions[formattingOption]);
  return {
    format: function format(date) {
      return dateFormatter.format(new Date(date));
    }
  };
};
export var cacheDateFormatter = function cacheDateFormatter(lng) {
  var cache = new Map();
  return function (formattingOption) {
    if (cache.has(formattingOption)) {
      return cache.get(formattingOption);
    }
    var formatter = makeDateFormatter(lng, formattingOption);
    cache.set(formattingOption, formatter);
    return formatter;
  };
};